import { LanguageEnum } from '@/interfaces/settings.interfaces';

export const LANGUAGES_MAP: Record<LanguageEnum, string> = {
  en: 'en-US',
  ru: 'ru-RU',
  idn: 'idn',
} as const;
